import type { CredentialsFormValues } from '../parts/shared/CredentialsStep';
import { AssociationOutcome } from './types';
import { postMspChildrenAssociation } from './postMspChildrenAssociation';

export interface CreateUnderParentParams {
  /** The SASE tenant being migrated - a MSSP child, or the MSSP parent itself. */
  tenantId: string;
  credentials: CredentialsFormValues;
}

/**
 * Shared by the MSSP Child "Create under Parent UUID" flow and the MSSP Parent
 * semi-migration. Both send the identical payload: MAPI decides which of the two
 * it is from the account document (P81-141608), so there is no mode field here.
 */
export const runCreateUnderParentAssociation = ({
  tenantId,
  credentials
}: CreateUnderParentParams): Promise<AssociationOutcome> => {
  // Do not log - payload contains secretKey, clientId, adminEmail.
  const payload = {
    tenantIds: [tenantId],
    mspParentTenantUUID: credentials.parentUuid,
    clientId: credentials.clientId,
    accessKey: credentials.secretKey,
    adminEmail: credentials.adminEmail
  };

  return postMspChildrenAssociation(payload);
};
